"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { extractFrameOperation } from "../_operations/extractFrame";

export function ExtractFrameContent() {
  return <MediaWorkspace operation={extractFrameOperation} />;
}
